import { withContext } from '@hilma/tools';
import { UserContext } from '../context';
/**
 * Function that returns a Higher Order Component with the `UserContext` value injected via the `user` prop
 * @param Component the component you want to inject the `UserContext` value into
 */
var withUser = withContext({ user: UserContext });
export default withUser;
//# sourceMappingURL=withUser.js.map